import './utils/functions';
import './menu';
import './language-cookie';
import './language-modal';
import './terms';
import './infinite-scroll';
import './faqs';
import './carousel';
import './filter';
import './back-top-top';
import './print';
import './tabs';
import './timezone';
import './select';
import './region-selector';
import './accordion';
import './gallery-lightbox';
import './google';
import './menu-sticky';
import './gsap';
import './cookie-notice';

import { SliderTracks } from './slider-tracks';
new SliderTracks(
	{
		elementSelector: '.related-posts-carousel.variable-width',
		pixelChange: 1,
		intervalSpeedMS: 20,
		timeToTransitionMS: 1000
	}
);
